import React, { useRef, useEffect } from 'react';
import './LoopMain.css';

interface LoopMainProps {
    analyser: AnalyserNode | null;
}

export function LoopMain({ analyser }: LoopMainProps): JSX.Element {
    const canvasRef = useRef<HTMLCanvasElement | null>(null);
    const getRandomColor = (): string => {
        const letters = '0123456789ABCDEF';
        let color = '#';
        for (let i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
    };

    const randomColor = getRandomColor()

    useEffect(() => {
        const canvas = canvasRef.current;
        if (!canvas || !analyser) return;
        const context = canvas.getContext('2d');
        if (!context) return;

        const bufferLength = analyser.fftSize;
        const dataArray = new Uint8Array(bufferLength);

        // Drawing the waveform using the analyser
        const drawWaveform = () => {
            if (!canvas || !context || !analyser) return;

            analyser.getByteTimeDomainData(dataArray);

            context.clearRect(0, 0, canvas.width, canvas.height);
            context.fillStyle = randomColor;
            context.fillRect(0, 0, canvas.width, canvas.height);

            context.lineWidth = 2;
            context.strokeStyle = 'white';
            context.beginPath();

            const sliceWidth = canvas.width / bufferLength;
            let x = 0;

            for (let i = 0; i < bufferLength; i++) {
                const v = dataArray[i] / 128.0;
                const y = (v * canvas.height) / 2;

                if (i === 0) {
                    context.moveTo(x, y);
                } else {
                    context.lineTo(x, y);
                }

                x += sliceWidth;
            }

            context.lineTo(canvas.width, canvas.height / 2);
            context.stroke();

            requestAnimationFrame(drawWaveform);
        };

        drawWaveform(); // Start drawing
    }, [analyser]); // Effect will run when the analyser node is updated

    return (
        <div className="LoopMain">
            <div className="LoopMain-canvas">
                <canvas ref={canvasRef} />
            </div>
        </div>
    );
}
